import React, { useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { string, bool, oneOfType } from "prop-types";
import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import brandTheme from "brandTheme/Theme";
import { Visibility } from "@material-ui/icons";
import {VisibilityOff} from "@material-ui/icons";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import { textFormat } from "utils/Utils";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import Tooltip from "@material-ui/core/Tooltip";
import { showMaskedCodeLos } from "assets/properties/properties";
const style = () => ({
  textField: {
    display: "block",
    width: "100%",
    borderColor: brandTheme.black,
    '& .Mui-disabled':{
      color:brandTheme.fieldColor,
      backgroundColor:brandTheme.disabled,
    },
    "& .MuiInputBase-input": {
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: "0 12px",
    }
    },
    '& .MuiFormLabel-root.Mui-error':{
      color: brandTheme.errorColor,
    },
    "& .MuiInputLabel-outlined": {
      color:brandTheme.black,
      fontSize:'14px',
      "@media (max-width:768px)":{
          fontSize:'13px',
        },
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color:brandTheme.black,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
      '& :hover':{
        borderColor: brandTheme.black,
      }
    },
    '& .MuiOutlinedInput-notchedOutline':{
      borderColor: brandTheme.black,
    },
  },
  textField1: {
    display: "block",
    width: "90%",
    borderColor: brandTheme.black,
    '& .Mui-disabled':{
      color:brandTheme.fieldColor,
      backgroundColor:brandTheme.disabled,
    },
    "& .MuiInputBase-input": {
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: "0 12px",
    }
    },
    '& .MuiFormLabel-root.Mui-error':{
      color: brandTheme.errorColor,
    },
    "& .MuiInputLabel-outlined": {
      color:brandTheme.black,
      fontSize:'14px',
      "@media (max-width:768px)":{
          fontSize:'13px',
        },
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color:brandTheme.black,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
      '& :hover':{
        borderColor: brandTheme.black,
      }
    },
    '& .MuiOutlinedInput-notchedOutline':{
      borderColor: brandTheme.black,
    },
  },
  searchField:{
    marginTop:'10px',
  },
});

const CustomeTextField = ({
  label,
  id,
  disabled,
  required,
  error,
  classes,
  onchange,
  search,
  setState,
  value,
  type,
  maxLength,
  setBlur,
  blurLabel,
  setError,
  setCharge,
  index,
  visiblityIcon,
  loanAccountNumber,
  viewType,
  lastFourDigits,
  validationState,
  validateThirdPartyAttemptsFlag,
  setIndexBlur
}) => {
  const [showVisbilityOff, setShowVisiblityOff] = useState(false)
  const [showError, setShowError] = useState(false)
  const [showErrorMsg, setShowErrorMsg] = useState("")
  const { authToken } = useSelector((state) => state.login.authData);
  const sideBarData = JSON.parse(sessionStorage.getItem("sideBarData") || "{}");
  const losListData = sideBarData?.losListData || [];
  const checkMaskedDataEnabled = losListData?.find((item)=> item?.code === showMaskedCodeLos);
const handleClickShowPassword = async () =>{
  const result = await apiHandler({
    url: endpoint.SHOW_MASKED + loanAccountNumber + '?view=' + viewType + "&lastFourDigit=" + lastFourDigits,
    authToken: authToken,
    method: "POST",
  });
  if(result?.data?.error_code === 403){
    setShowErrorMsg(`This role doesn't have access`)
    setShowError(true) 
  }else if(result?.data?.error_code){
    setShowErrorMsg(result?.data?.user_description)
    setShowError(true) 
  }
  else{
    setShowVisiblityOff(true)
  }
}
const handleClickhidePassword = ()=>{
  setShowVisiblityOff(false)
  setShowError(false)
}

  return (
    <div className={classes.textField}>
      {search ? (
        <TextField
        className={classes.searchField}
          error={error}
          required={required}
          id={id}
          label={label}
          variant="outlined"
          style={{
            width: "100%",
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
            style: { width: "100%" },
          }}
          onChange={onchange}
          size="small"
        />
      ) : (
        <div style={{ position:'relative'}}>
        <TextField
          error={error}
          size="small"
          id={id}
          label={
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span>
                {label}
                {required && <span>*</span>}
              </span>
              {validateThirdPartyAttemptsFlag && (
                <>
                  {validationState?.success === true && (
                    <Tooltip title="Valid">
                      <CheckCircleIcon style={{ color: 'green', fontSize: 18 }} />
                    </Tooltip>
                  )}
                  {validationState?.error === true && (
                    <Tooltip title="Invalid">
                      <CancelIcon style={{ color: 'red', fontSize: 18 }} />
                    </Tooltip>
                  )}
                </>
              )}
            </div>
          }
          variant="outlined"
          value={!showVisbilityOff && visiblityIcon ? value?.replace(/\d(?=\d{4})/g, "*") : value}
          disabled={disabled}
          style={{
            width: "100%",
           
          }}
          InputLabelProps={{ shrink: value ? true : false }}
          type={type}
          onChange={(event) => {
            if(setCharge){
              setCharge(index,type,event.target.value);
            }if(type==='notCapital'){
            setState(event.target.value);}
            else if(type==="allValue"){
              setState(event)
            }else if (type === "gst") {
              const formatted = event.target.value
                .replace(/[^a-zA-Z0-9]/g, "")
                .toUpperCase();
              setState(formatted);
            }
            else if (type === "alphabets") {
              setState(textFormat(event.target.value.replace(/[^a-zA-Z\s]/g, "")));
            }
            else if (type === "digits") {
              setState(event.target.value.replace(/[^0-9]/g, ""));
            }
            else{
              setState(textFormat(event.target.value))
            }
          }   
          }
          onBlur={(event) => {
            if(setIndexBlur) setIndexBlur(event,index)
            if(setBlur) setBlur(event.target.value, blurLabel);
            if(setError) setError(false)
          }
          }
          inputProps={{ maxLength: maxLength }}
        />
         {(visiblityIcon && !showVisbilityOff && !checkMaskedDataEnabled?.disabled ) &&   <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              edge="end"
              style={{position:'absolute', right: 10, top:-3}}
            > <Visibility/>
            </IconButton>
}
            {(visiblityIcon && showVisbilityOff ) &&  <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickhidePassword}
              edge="end"
              style={{position:'absolute', right: 10, top:-3}}
            > <VisibilityOff/> 
            </IconButton>

          }
         
         {visiblityIcon && showError && <span style={{color:'red', fontSize:'10px', textAlign:'left', width:'100%', fontWeight:700}}>{showErrorMsg}</span>}
         </div>
      )}
    </div>
  );
};

CustomeTextField.propTypes = {
  label: string,
  id: string,
  required: bool,
  validationState: oneOfType([bool, null]),
};
CustomeTextField.defaultProps = {
  label: "",
  id: "text-field",
  required: false,
};
export default withStyles(style)(CustomeTextField);